// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-CurrentLocationButton__wrapper","label":"c-CurrentLocationButton__label"};